import { ReputationLandlordIntentionType, ZgBrand } from '@zg-rentals/ts-rental-manager-api-beta-client';

export const mapBrandStringToEnum = (brand: string): ZgBrand => {
  let brandEnum: ZgBrand;
  if (brand.toLowerCase() === 'hotpads') {
    brandEnum = ZgBrand.HOTPADS;
  } else if (brand.toLowerCase() === 'trulia') {
    brandEnum = ZgBrand.TRULIA;
  } else {
    brandEnum = ZgBrand.ZILLOW;
  }
  return brandEnum;
};

export const mapIntentionTypeStringToEnum = (intentionType: string): ReputationLandlordIntentionType | null => {
  let intentionTypeEnum;
  if (intentionType.toLowerCase() === 'call') {
    intentionTypeEnum = ReputationLandlordIntentionType.CALL;
  } else if (intentionType.toLowerCase() === 'sms') {
    intentionTypeEnum = ReputationLandlordIntentionType.SMS;
  } else if (intentionType.toLowerCase() === 'reportinquiryasspam') {
    intentionTypeEnum = ReputationLandlordIntentionType.REPORT_INQUIRY_AS_SPAM;
  } else {
    intentionTypeEnum = null;
  }
  return intentionTypeEnum;
};
